import { Events, Schema, SessionIdSymbol, State, makeSchema } from "@livestore/livestore";

export const tables = {
  files: State.SQLite.table({
    name: "files",
    columns: {
      path: State.SQLite.text({ primaryKey: true }),
    },
  }),
  uiState: State.SQLite.clientDocument({
    name: "uiState",
    schema: Schema.Struct({
      inputText: Schema.String,
      selectedIndex: Schema.Number,
      cursorPos: Schema.Number,
    }),
    default: {
      id: SessionIdSymbol,
      value: { inputText: "", selectedIndex: 0, cursorPos: 0 },
    },
  }),
};

export const events = {
  fileAdded: Events.synced({
    name: "v1.FileAdded",
    schema: Schema.Struct({ path: Schema.String }),
  }),
  uiStateSet: tables.uiState.set,
};

const materializers = State.SQLite.materializers(events, {
  "v1.FileAdded": ({ path }) => tables.files.insert({ path }),
});

const state = State.SQLite.makeState({ tables, materializers });

export const schema = makeSchema({ events, state });
